import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";
import { Button, Grid, Menu, Typography } from "@mui/material";
import { useState } from "react";
import useColors from "../../../../../../api/hooks/useColors";

export default function DropDownButton({
  text,
  children,
  onClose = () => {},
  menuStyle = null,
  open = null,
  onClick = () => {},
  ...props
}) {
  const colors = useColors();
  const [anchorEl, setAnchorEl] = useState(null);
  const [menuIsOpen, setMenuOpen] = useState(false);

  const handleClick = (event) => {
    onClick();
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    onClose();
    setAnchorEl(null);
    setMenuOpen(false);
  };

  const { sx, ...restProps } = props;

  return (
    <>
      <Button
        onClick={handleClick}
        sx={{
          background: colors.grey_50,
          color: colors.text_primary,
          height: "32px",
          border: "1px solid " + colors.grey_32percent,
          textTransform: "unset",
          borderRadius: "10px",
          fontSize: "12px",
          display: "flex",
          justifyContent: "space-evenly",
          ...sx,
        }}
        {...restProps}
      >
        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          paddingLeft="2px"
        >
          <Typography variant="caption">{text}</Typography>
          <KeyboardArrowDownRoundedIcon
            style={{ width: "20px", height: "20px" }}
          />
        </Grid>
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open !== null ? open : menuIsOpen}
        onClose={handleMenuClose}
        sx={{
          color: colors.contrast_text_dark,
          "& .MuiPaper-root": {
            border: "1px solid " + colors.divider2,
            borderRadius: "6px",
            boxShadow: 0,
          },
          ...menuStyle,
        }}
      >
        {children}
      </Menu>
    </>
  );
}
